import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) method = iterable[Symbol.asyncIterator]; if (method == null && Symbol.iterator) method = iterable[Symbol.iterator]; } if (method == null) method = iterable["@@asyncIterator"]; if (method == null) method = iterable["@@iterator"]; if (method == null) throw new TypeError("Object is not async iterable"); return method.call(iterable); }

import webkitGetAsEntryApi from './utils/webkitGetAsEntryApi/index.js';
import fallbackApi from './utils/fallbackApi.js';
/**
 * Returns a promise that resolves to the array of dropped files (if a folder is
 * dropped, and browser supports folder parsing - promise resolves to the flat
 * array of all files in all directories).
 * Each file has .relativePath prop appended to it (e.g. "/docs/Prague/ticket_from_prague_to_ufa.pdf")
 * if browser supports it. Otherwise it's undefined.
 *
 * @param {DataTransfer} dataTransfer
 * @param {Function} logDropError - a function that's called every time some
 * folder or some file error out (e.g. because of the folder name being too long
 * on Windows). Notice that resulting promise will always be resolved anyway.
 *
 * @returns {Promise} - Array<File>
 */

export default function getDroppedFiles(_x, _x2) {
  return _getDroppedFiles.apply(this, arguments);
}

function _getDroppedFiles() {
  _getDroppedFiles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dataTransfer, _temp) {
    var _ref, _ref$logDropError, logDropError, accumulator, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, file;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _temp === void 0 ? {} : _temp, _ref$logDropError = _ref.logDropError, logDropError = _ref$logDropError === void 0 ? function () {} : _ref$logDropError; // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari

            _context.prev = 1;
            accumulator = [];
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 5;
            _iterator = _asyncIterator(webkitGetAsEntryApi(dataTransfer, logDropError));

          case 7:
            _context.next = 9;
            return _iterator.next();

          case 9:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 15;
              break;
            }

            file = _step.value;
            accumulator.push(file);

          case 12:
            _iteratorAbruptCompletion = false;
            _context.next = 7;
            break;

          case 15:
            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 21:
            _context.prev = 21;
            _context.prev = 22;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 26;
              break;
            }

            _context.next = 26;
            return _iterator.return();

          case 26:
            _context.prev = 26;

            if (!_didIteratorError) {
              _context.next = 29;
              break;
            }

            throw _iteratorError;

          case 29:
            return _context.finish(26);

          case 30:
            return _context.finish(21);

          case 31:
            return _context.abrupt("return", accumulator);

          case 34:
            _context.prev = 34;
            _context.t1 = _context["catch"](1);
            return _context.abrupt("return", fallbackApi(dataTransfer));

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 34], [5, 17, 21, 31], [22,, 26, 30]]);
  }));
  return _getDroppedFiles.apply(this, arguments);
}